// enum of types of flags provided by Cloudbees
export const FLAG_TYPES = {
  BOOLEAN: 'boolean',
  STRING: 'string',
  NUMBER: 'number',
}
